import {networkService as network} from '@/services'

import { userService } from "@/services/userService";

export let userInfo = null

export const UserInfo = {
  async getUserInfo() {
    //if(userInfo === null) {
    /* Пока так сделано, потому что нет контроля над UserID и вылазят баги. Планируется рефакторинг на 3 итерацию */
      return await userService.getUserSelf().then(data => userInfo = data).catch(e => console.log('Not found user:', e))
    //} else {
      //return userInfo
    //}
  },
  resetUser() {
    return userInfo = null
  }

}